import React, { Component } from "react";

import { Grid, Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card } from "components/Card/Card.jsx";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";

import { adminUserActions } from '../../redux/actions/admin-user-action';
import { companyActions } from '../../redux/actions/company-action';
import { confirmAlert } from 'react-confirm-alert';

import companyIcon from "assets/img/company_orange.svg";
import festivalsIcon from "assets/img/festivals.svg";

import 'react-confirm-alert/src/react-confirm-alert.css';



class DashboardSuperAdminPage extends Component {
  constructor(props){
    super(props);
    this.state = {
      dashboardCount : {},
      latestCompanies : {}
    };

    this.deleteCompany = this.deleteCompany.bind(this);
    this.deleteConfirmCompany = this.deleteConfirmCompany.bind(this);

  }

  deleteConfirmCompany(id){
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body">
              <h3>Delete Company</h3>
              <p className="marginFromTopPopUp" >Are you sure to delete the company?</p>
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>No</button>
                <button onClick={() => {
                    this.deleteCompany(id)
                    onClose()
                }}>Yes</button>
              </div>
            </div>
            
          </div>
        )
      }
    })
  }

  deleteCompany(id){
    this.props.deleteCompanyCall(id);
  }
  componentDidMount() {
    this.props.getDashboardCall();
    this.props.getLatestCompanyCall();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.dashboardCount){
      this.setState({dashboardCount:nextProps.dashboardCount});
    }

    if (nextProps.data){
      this.setState({latestCompanies:nextProps.data});
    }
  }
  render() {
    const { dashboardCount, latestCompanies } = this.state;
    return (
      <div className="content">
        <Grid fluid>
          {
            dashboardCount &&
            <Row>
              <Col lg={6} sm={12}>
                <StatsCard
                  bigIcon={<img height="70" src={companyIcon} alt="companyIconImage" />}
                  statsText="Total number of Companies"
                  statsValue={dashboardCount.total_companies}
                  statsIcon={<Link to={'/Admin/Companies'}>{<img height="15" src={companyIcon} alt="companyIconImage" />}</Link>}
                  statsIconText="Companies"
                />
              </Col>
              <Col lg={6} sm={12}>
                <StatsCard
                  bigIcon={<img height="70" src={festivalsIcon} alt="festivalsIconImage" />}
                  statsText="Total number of Festivals"
                  statsValue={dashboardCount.total_festivals}
                  statsIcon={<Link to={'/Admin/Festivals'}>{<img height="15" src={festivalsIcon} alt="festivalsIconImage" />}</Link>}
                  statsIconText="Festivals"
                />
              </Col>
            </Row>
          }
        </Grid>

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Recent Companies"
                ctTableResponsive
                content={
                  <div>
                  { latestCompanies && latestCompanies.length > 0 &&
                    <Table striped hover className="myTable">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Address 1</th>
                          <th>City</th>
                          <th>State</th>
                          <th>Zip</th>
                          <th className="action-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {latestCompanies.map((prop, key) => {
                          return (
                            <tr key={key}>
                              <td>{prop.name}</td>
                              <td>{prop.address1}</td>
                              <td>{prop.city}</td>
                              <td>{prop.state}</td>
                              <td>{prop.zip}</td>
                              <td className="action-center">
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Company Users</Tooltip>}>
                                  <Link to={'/Admin/Company/'+prop.id+'/users'} className="action-button-size"><i className="fa fa-users " /></Link>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit Company</Tooltip>}>
                                  <Link to={'/Admin/Edit-Company/'+prop.id} className="action-button-size"><i className="fa fa-pencil" /></Link>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Delete Company</Tooltip>}>
                                  <button onClick={()=>this.deleteConfirmCompany(prop.id)} className="action-button-size"><i className="fa fa-trash " /></button>
                                </OverlayTrigger>
                              </td>
                              
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  }

                   { latestCompanies && latestCompanies.length === 0 &&
                      <h4>No Company Found</h4>
                   }
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}



const mapDispatchToProps = dispatch => {
  return ({
    deleteCompanyCall  : (id) => { dispatch(companyActions.deleteCompany(id)) },
    getDashboardCall  : () => { dispatch(adminUserActions.dashboard()) },
    getLatestCompanyCall  : () => { dispatch(companyActions.getCompaniesPagination(1, '', '', 10)) }
  });
};


function mapStateToProps(state) {
    const { dashboardCount, loading } = state.adminReducer;
    const { data } = state.companyReducer;
    return {
        dashboardCount,loading, data
    };
}

const DashboardSuperAdmin = connect(mapStateToProps, mapDispatchToProps)(DashboardSuperAdminPage);


export default DashboardSuperAdmin;



// WEBPACK FOOTER //
// ./src/components/Admin/DashboardSuperAdmin.jsx